<template>
    <b-card-group deck class="mx-3 my-2" v-loading="is_loading">
        <b-row class="w-100" v-if="!is_loading && tableData.length > 0">
            <b-col md="3" v-for="(data, index) in tableData" :key="index">
                <PropertyApplicationCard 
                    :is_editable="is_editable"
                    @remove-product-application="removeProductApplication"
                    :product_application="data" 
                    v-if="data.pcom_product_detail.pcp_product_type.toLowerCase() === 'property'"
                />
                <MortgageApplicationCard
                    :is_editable="is_editable"
                    @remove-product-application="removeProductApplication"
                    :product_application="data" 
                    v-if="data.pcom_product_detail.pcp_product_type.toLowerCase() === 'mortgage'"
                />
                <PersonalLoanApplicationCard
                    :is_editable="is_editable"
                    @remove-product-application="removeProductApplication"
                    :product_application="data" 
                    v-if="data.pcom_product_detail.pcp_product_type.toLowerCase() === 'personal_loan'"
                />
                <InsuranceApplicationCard
                    :is_editable="is_editable"
                    @remove-product-application="removeProductApplication"
                    :product_application="data" 
                    v-if="data.pcom_product_detail.pcp_product_type.toLowerCase() === 'insurance'"
                />
                <RefinancingApplicationCard
                    :is_editable="is_editable"
                    @remove-product-application="removeProductApplication"
                    :product_application="data" 
                    v-if="data.pcom_product_detail.pcp_product_type.toLowerCase() === 'refinance'"
                />
                <OtherLoanApplicationCard
                    :is_editable="is_editable"
                    @remove-product-application="removeProductApplication"
                    :product_application="data" 
                    v-if="data.pcom_product_detail.pcp_product_type.toLowerCase() === 'other'"
                />
            </b-col>
        </b-row>
        <b-row v-else>
            <b-col>
                <p>No Products Found.</p>
            </b-col>
        </b-row>
    </b-card-group>
</template>
<script>
import PropertyApplicationCard from '@/views/InitialProposal/Cards/PropertyApplicationCard.vue'
import MortgageApplicationCard from '@/views/InitialProposal/Cards/MortgageApplicationCard.vue'
import PersonalLoanApplicationCard from '@/views/InitialProposal/Cards/PersonalLoanApplicationCard.vue'
import InsuranceApplicationCard from '@/views/InitialProposal/Cards/InsuranceApplicationCard.vue'
import RefinancingApplicationCard from '@/views/InitialProposal/Cards/RefinancingApplicationCard.vue'
import OtherLoanApplicationCard from '@/views/InitialProposal/Cards/OtherLoanApplicationCard.vue'
import initialProposalEventBus from '@/assets/js/EventBus/initialProposalEventBus.js'
import {swal } from '@/assets/js/httpImports.js'
import { mapActions, mapState } from 'pinia'
import { useInitialProposalStore } from '@/stores/initialProposalStore'

export default {
    props:['psal_id','is_editable'],
    components: {
        OtherLoanApplicationCard,
        InsuranceApplicationCard,
        PropertyApplicationCard,
        PersonalLoanApplicationCard,
        MortgageApplicationCard,
        RefinancingApplicationCard
    },
		data() {
			return {
				is_loading: false,
				tableData: []
			}
		},
		watch: {
			psal_id: {
				handler(newVal) {
					if(!_gHlp.isEmpty(newVal)){
						this.getListing(newVal)
					}
				},
				immediate: true,
			}
		},
    methods:{
				...mapActions(useInitialProposalStore, ['deleteProposalCommitment','getProposalCommitmentList']),
				getListing(psal_id){
					this.is_loading = true;
					this.tableData = []
					let params = {
						search:{
							pcom_psal_id: psal_id,
							pcom_kind: 'product'
						},
						paginate:'no_paginate'
					}
					this.getProposalCommitmentList(params).then(resp => {
						this.tableData = _gHlp.getValue(resp,'data',[]);
						this.is_loading = false;
					}).catch(e => {
						_gNotif.errorFunction(e)
						this.is_loading = false;
					})
				},
        removeProductApplication(id){
					swal.fire({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then(async (result) => {
							if (result.isConfirmed) {
								this.is_loading = true;
								if(await this.deleteProposalCommitment(id)){
									_gNotif.notifySuccess('<b>Proposal:</b> - Successfully Removed Product.')
									initialProposalEventBus.$emit('refresh-proposal-detail')
								}
								this.is_loading = false;
							}
						})
        }
    }
}
</script>